import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { getClinicBannerUrl } from '../../../utils/config';
import "./HeroBanner.css";

const HeroBanner = ({ user }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [bannerUrl, setBannerUrl] = useState(null);
    const defaultBanner = "/images/landing_two.jpeg";

    useEffect(() => {
        if (user) {
            const clinicBanner = getClinicBannerUrl(user);
            if (clinicBanner) {
                setBannerUrl(clinicBanner); // Use clinic-specific banner
            } else {
                setBannerUrl(defaultBanner); // Fallback to default banner
            }
        }
    }, [user]);
    

    // Ensure we wait for `user` before rendering
    if (!user) return null;

    const isCustomClinic = !!getClinicBannerUrl(user);

    return (
        <div 
            className="hero-banner" 
            style={{ backgroundImage: `linear-gradient(rgba(0, 119, 182, 0.2), rgba(255, 255, 255, 0)), url(${bannerUrl || defaultBanner}) , url(${bannerUrl})` }}
        >
            <div className="hero-overlay"></div>
            <div className="hero-content">
                {isCustomClinic ? (
                    <>
                        <h1 className="hero-title animate-title">{t("hero.clinic_specific_banner_title")}</h1>
                        <p className="hero-subtitle animate-subtitle">{t("hero.clinic_specific_banner_description")}</p>
                        {/* <ul className="hero-benefits">
                            <li>{t("hero.benefit_1")}</li>
                            <li>{t("hero.benefit_2")}</li>
                            <li>{t("hero.benefit_3")}</li>
                            <li>{t("hero.benefit_4")}</li>
                        </ul> */}
                    </>
                
                ) : (
                    <>
                        <h1 className="hero-title animate-title">{t("hero.empower_wellness")}</h1>
                        <p className="hero-subtitle animate-subtitle">{t("hero.discover_health_path")}</p>
                        <button 
                            className="hero-cta animate-cta" 
                            onClick={() => navigate('/contact')}
                        >
                            {t("hero.book_demo")}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default HeroBanner;
